import { get } from 'lodash-es';
/**
 * @param filterStr
 */
export function parseFilterRule(filterStr) {
    const [action, , field, comparator, value] = filterStr.split(' ');
    return {
        action: action.toUpperCase(),
        where: {
            field,
            comparator: comparator.toUpperCase(),
            value,
        },
    };
}
/**
 * @param filterRule
 */
export function stringifyFilterRule(filterRule) {
    const action = filterRule.action.toUpperCase();
    const { field, value } = filterRule.where;
    const comparator = filterRule.where.comparator.toUpperCase();
    return `${action} WHERE ${field} ${comparator} ${value}`;
}
/**
 * @param filterRule
 * @param data
 */
export function evaluateFilter(filterRules, data) {
    return data.reduce((acc, item) => {
        let resultingAction;
        // eslint-disable-next-line
        for (const { action, where } of filterRules) {
            switch (where.comparator) {
                case 'EQUALS':
                    if (String(get(item, where.field, null)) === where.value)
                        resultingAction = action;
                    break;
                case 'CONTAINS':
                    if (String(get(item, where.field, null)).includes(where.value))
                        resultingAction = action;
                    break;
                case 'IN':
                    if (where.value.split(',').includes(String(get(item, where.field, null))))
                        resultingAction = action;
                    break;
                default:
                    throw Error(`Invalid comparator: ${where.comparator}`);
            }
        }
        if (resultingAction === 'ADD') {
            acc.push(item);
        }
        return acc;
    }, []);
}
